import { QuizStudent } from 'platform-components';
import { Route, Switch, Redirect } from 'platform-components/src/components/router/router';
import { withRouterPath } from 'platform-components/hocs';
import PropTypes from 'prop-types';
import React from 'react';

import Lessons from '../class-lessons/class-lessons';
import Class from '../class/class';
import CourseJournal from '../course-journal/course-journal';
import CourseViewLoader from '../course-view-loader/course-view-loader';
import { TeacherExamsTraining } from '../exams-training/exams-training';
import { ExternalShowAssignedLessonPage } from '../external-show-assigned-lesson-page/external-show-assigned-lesson-page';
import { ProfilePage } from '../profile/profile';
import Journal from '../journal/journal';
import LessonSandbox from '../lesson-sandbox/lesson-sandbox';
import { Library, LibraryPreview } from '../library.index/library';
import { LibraryMain } from '../library.main/library-main';
import { Portfolio } from '../portfolio/portfolio';
import { QuizEditor } from '../quiz-editor/quiz-editor';
import { QuizPage } from '../quiz-page/quiz-page';
import { SpecCourseEmptyContainer } from '../spec-course.empty/empty.container';
import { SpecCourseContainer } from '../spec-course/spec-course.container';
import { TeacherKPKsPage } from '../teacher-kpks-page';
import { TeacherReservePage } from '../teacher-reserve-page';
import LessonCardLoadable from '../lesson-card/lesson-card__loadable';
import { AuthProvider } from '../../../../common.components/TeacherHeader/lib/AuthProvider';

import 'education-components/dist/user/index.css';
import 'education-components/dist/header/index.css';

const ProtectedRouteWithAuth = ({ component: Component, render, ...rest }) => (
    <Route
        {...rest}
        render={(routeProps) => (
            <AuthProvider>{Component ? <Component {...routeProps} /> : render?.(routeProps)}</AuthProvider>
        )}
    />
);

export class TeacherLab extends React.Component {
    static propTypes = {
        location: PropTypes.shape({
            search: PropTypes.string,
            pathname: PropTypes.string,
        }),
    };

    static contextTypes = {
        staticUrls: PropTypes.object.isRequired,
    };

    // eslint-disable-next-line complexity
    render() {
        const { staticUrls } = this.context;
        const {
            location: { search },
        } = this.props;

        if (!isSSR && location.pathname.includes('/new-lab')) {
            window.location.href = window.location.origin + location.pathname;
            return null;
        }

        return (
            <Switch>
                <ProtectedRouteWithAuth
                    component={LibraryPreview}
                    exact
                    key="LibraryPreview"
                    path={staticUrls.labCoursesPreview}
                />
                <ProtectedRouteWithAuth
                    component={LibraryPreview}
                    exact
                    key="LibraryPreview"
                    path={staticUrls.labPreviewSubject}
                />
                <ProtectedRouteWithAuth
                    component={LibraryPreview}
                    exact
                    key="LibraryPreview"
                    path={staticUrls.labPreviewSubjectGrade}
                />
                <ProtectedRouteWithAuth
                    component={LibraryPreview}
                    exact
                    key="LibraryPreview"
                    path={staticUrls.labPreviewCourse}
                />
                <ProtectedRouteWithAuth
                    component={LibraryPreview}
                    exact
                    key="LibraryPreview"
                    path={staticUrls.labClassCoursesPreview}
                />
                <ProtectedRouteWithAuth
                    component={LibraryPreview}
                    exact
                    key="LibraryPreview"
                    path={staticUrls.labClassCoursesPreviewSubject}
                />
                <ProtectedRouteWithAuth
                    component={LibraryPreview}
                    exact
                    key="LibraryPreview"
                    path={staticUrls.labClassCoursesPreviewSubjectGrade}
                />
                <ProtectedRouteWithAuth
                    component={LibraryPreview}
                    exact
                    key="LibraryPreview"
                    path={staticUrls.labClassCoursesPreviewCourse}
                />
                {/*
                    часть адреса "results" используется в
                    lesson-run__teacher-popup.jsx и в teacher-lab.jsx
                */}
                <Redirect exact path={staticUrls.labHome} to={staticUrls.labLibrary} />
                <ProtectedRouteWithAuth component={Class} exact key="Class" path={staticUrls.labClasses} />
                <ProtectedRouteWithAuth component={Class} key="Class" path={staticUrls.labClass} />
                <ProtectedRouteWithAuth
                    component={QuizPage}
                    exact
                    key="QuizPage"
                    path={[staticUrls.labQuizGame, staticUrls.labQuiz]}
                />
                <ProtectedRouteWithAuth component={QuizStudent} key="QuizStudent" path={'/lab/quiz-student/'} />
                <ProtectedRouteWithAuth
                    exact
                    key="QuizEditor"
                    path={staticUrls.labCreateQuiz}
                    render={() => <QuizEditor view="create" />}
                />
                <ProtectedRouteWithAuth
                    exact
                    key="QuizEditor"
                    path={staticUrls.labEditQuiz}
                    render={() => <QuizEditor view="edit" />}
                />
                <ProtectedRouteWithAuth
                    exact
                    key="QuizEditor"
                    path={staticUrls.labQuizEditPreview}
                    render={() => <QuizEditor readonly view="edit" />}
                />
                <ProtectedRouteWithAuth
                    exact
                    key="QuizEditor"
                    path={staticUrls.labPreviewQuiz}
                    render={() => <QuizEditor readonly view="preview" />}
                />
                <ProtectedRouteWithAuth
                    exact
                    key="LessonQuizEditor"
                    path={staticUrls.labLessonPreviewQuiz}
                    render={() => <QuizEditor readonly view="preview" />}
                />
                <ProtectedRouteWithAuth component={Lessons} exact key="Lessons" path={staticUrls.labLessons} />
                <ProtectedRouteWithAuth component={Portfolio} exact key="Portfolio" path={staticUrls.labPortfolio} />
                <ProtectedRouteWithAuth
                    component={TeacherKPKsPage}
                    exact
                    key="TeacherKPKsPage"
                    path={staticUrls.labTeacherTrainingCourses}
                />
                <ProtectedRouteWithAuth
                    component={TeacherReservePage}
                    exact
                    key="TeacherReservePage"
                    path={staticUrls.labTeacherReserve}
                />
                <ProtectedRouteWithAuth
                    component={TeacherReservePage}
                    exact
                    key="labClassTeacherReserve"
                    path={staticUrls.labClassTeacherReserve}
                />
                <Redirect
                    exact
                    path={staticUrls.labSubjectLessons}
                    to={{
                        pathname: staticUrls.labSubjectLessonsComplete,
                        search,
                    }}
                />
                <ProtectedRouteWithAuth
                    component={CourseViewLoader}
                    exact
                    key="CourseViewLoader"
                    path={staticUrls.labClassLessons}
                />
                <ProtectedRouteWithAuth
                    component={CourseViewLoader}
                    exact
                    key="CourseViewLoader"
                    path={staticUrls.labSubjectLessonsComplete}
                />
                <ProtectedRouteWithAuth
                    component={CourseViewLoader}
                    exact
                    key="CourseViewLoader"
                    path={staticUrls.labSubjectLessonsActive}
                />
                <ProtectedRouteWithAuth
                    component={CourseViewLoader}
                    exact
                    key="CourseViewLoader"
                    path={staticUrls.labSubjectLessonsDrafts}
                />
                <ProtectedRouteWithAuth
                    component={CourseViewLoader}
                    exact
                    key="CourseViewLoader"
                    path={staticUrls.labSubjectLessonsCalendar}
                />
                <ProtectedRouteWithAuth
                    component={CourseViewLoader}
                    exact
                    key="CourseViewLoader"
                    path={staticUrls.labSubjectLessonsSkillsStats}
                />
                <ProtectedRouteWithAuth component={Journal} exact key="Journal" path={staticUrls.labJournal} />
                <ProtectedRouteWithAuth
                    component={CourseJournal}
                    exact
                    key="CourseJournal"
                    path={staticUrls.labClassJournal}
                />
                <ProtectedRouteWithAuth
                    component={CourseJournal}
                    exact
                    key="CourseJournal"
                    path={staticUrls.labSubjectJournal}
                />
                <ProtectedRouteWithAuth
                    component={LibraryMain}
                    exact
                    key="LibraryMain"
                    path={staticUrls.labLibraryMain}
                />
                <ProtectedRouteWithAuth
                    component={LibraryMain}
                    exact
                    key="LibraryMain"
                    path={staticUrls.labLibraryTeamMain}
                />
                <ProtectedRouteWithAuth component={Library} exact key="Library" path={staticUrls.deepLabLibrary} />
                <ProtectedRouteWithAuth component={Library} exact key="Library" path={staticUrls.labLibrary} />
                <ProtectedRouteWithAuth component={Library} exact key="Library" path={staticUrls.labClassLibrary} />
                <Redirect exact path={staticUrls.labClassesLibrary} to={staticUrls.labClasses} />
                <ProtectedRouteWithAuth component={Library} exact key="Library" path={staticUrls.labLibrarySubject} />
                <ProtectedRouteWithAuth
                    component={Library}
                    exact
                    key="Library"
                    path={staticUrls.labLibrarySubjectProgram}
                />
                <Redirect exact path={staticUrls.labLibrarySubjectThemes} to={staticUrls.deepLabTheme} />
                <ProtectedRouteWithAuth component={Library} exact key="Library" path={staticUrls.deepLabTheme} />
                <ProtectedRouteWithAuth
                    component={Library}
                    exact
                    key="Library"
                    path={staticUrls.labLibrarySubjectTheme}
                />
                <ProtectedRouteWithAuth component={Library} exact key="Library" path={staticUrls.deepLabStacks} />
                <ProtectedRouteWithAuth
                    component={Library}
                    exact
                    key="Library"
                    path={staticUrls.labLibrarySubjectThemeStacks}
                />
                <ProtectedRouteWithAuth component={Library} exact key="Library" path={staticUrls.deepLabThemeLessons} />
                <ProtectedRouteWithAuth
                    component={Library}
                    exact
                    key="Library"
                    path={staticUrls.labLibrarySubjectThemeLessons}
                />
                <ProtectedRouteWithAuth
                    component={Library}
                    exact
                    key="Library"
                    path={staticUrls.labLibrarySubjectCollection}
                />
                <ProtectedRouteWithAuth
                    component={LessonCardLoadable}
                    exact
                    key="LessonCard"
                    path={staticUrls.labLibrarySubjectLessonCard}
                />
                <ProtectedRouteWithAuth
                    component={Library}
                    exact
                    key="Library"
                    path={staticUrls.labLibrarySubjectCommonCourseContainer}
                />
                <ProtectedRouteWithAuth
                    component={Library}
                    exact
                    key="Library"
                    path={staticUrls.labLibraryActualThemes}
                />
                <ProtectedRouteWithAuth
                    component={Library}
                    exact
                    key="Library"
                    path={staticUrls.labClassLibrarySubjectTab}
                />
                <ProtectedRouteWithAuth
                    component={Library}
                    exact
                    key="Library"
                    path={staticUrls.labLibrarySubjectTab}
                />
                <ProtectedRouteWithAuth
                    component={Library}
                    exact
                    key="Library"
                    path={staticUrls.labLibraryCalendarPlanShowcaseLesson}
                />
                <ProtectedRouteWithAuth
                    component={Library}
                    exact
                    key="Library"
                    path={staticUrls.labClassLibraryCalendarPlanShowcaseLesson}
                />
                <ProtectedRouteWithAuth
                    component={Library}
                    exact
                    key="Library"
                    path={staticUrls.deepLabPromoTabSection}
                />
                <ProtectedRouteWithAuth
                    component={Library}
                    exact
                    key="Library"
                    path={staticUrls.labLibrarySubjectPromo}
                />
                <ProtectedRouteWithAuth
                    component={Library}
                    exact
                    key="Library"
                    path={staticUrls.labLibrarySubjectCalendarPlan}
                />
                <ProtectedRouteWithAuth
                    component={Library}
                    exact
                    key="Library"
                    path={staticUrls.labClassLibrarySubjectCalendarPlan}
                />
                <ProtectedRouteWithAuth
                    component={Library}
                    exact
                    key="Library"
                    path={staticUrls.labClassLibrarySubjectCalendarPlanTheme}
                />
                <ProtectedRouteWithAuth
                    component={Library}
                    exact
                    key="Library"
                    path={staticUrls.labLibrarySubjectCalendarPlanTheme}
                />
                <ProtectedRouteWithAuth
                    component={LessonSandbox}
                    exact
                    key="LessonSandbox"
                    path={staticUrls.lessonSandbox}
                />
                <ProtectedRouteWithAuth
                    component={SpecCourseContainer}
                    exact
                    key="SpecCourseContainer"
                    path={staticUrls.labClassSpecCourseLesson}
                />
                <ProtectedRouteWithAuth
                    component={SpecCourseEmptyContainer}
                    exact
                    key="SpecCourseEmptyContainer"
                    path={staticUrls.labSpecCourse}
                />
                <ProtectedRouteWithAuth
                    component={TeacherExamsTraining}
                    exact
                    key="labExams"
                    path={staticUrls.labClassExams}
                />
                <ProtectedRouteWithAuth
                    component={TeacherExamsTraining}
                    exact
                    key="labExams"
                    path={staticUrls.labExams}
                />
                <ProtectedRouteWithAuth
                    component={SpecCourseContainer}
                    exact
                    key="SpecCourseContainer"
                    path={staticUrls.labClassSpecCourseStub}
                />
                <ProtectedRouteWithAuth
                    component={SpecCourseContainer}
                    exact
                    key="SpecCourseContainer"
                    path={staticUrls.labClassSpecCourse}
                />

                <ProtectedRouteWithAuth
                    component={ExternalShowAssignedLessonPage}
                    exact
                    key="external"
                    path={staticUrls.externalShowAssignedLesson}
                />

                <Route component={ProfilePage} exact key="external" path={staticUrls.labPersonalAccountMain} />
            </Switch>
        );
    }
}

const TeacherLabRoutes = withRouterPath(TeacherLab);

const routes = (props, { staticUrls: { labHome } }) => <Route component={TeacherLabRoutes} path={labHome} {...props} />;
routes.contextTypes = {
    staticUrls: PropTypes.object.isRequired,
};

export { routes };
